var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "menu--section_nav menu--glass_effect menu--glass_effect-opaque",
      class: _vm.containerClasses,
      on: {
        click: function ($event) {
          $event.stopPropagation()
          _vm.isExpanded = false
        },
      },
    },
    [
      _c("a", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: (_vm.menu?.sections.length || 0) > 1,
            expression: "(menu?.sections.length || 0) > 1",
          },
        ],
        staticClass: "menu--section_nav_handle material-icons",
        attrs: {
          href: "#",
          title: _vm.isExpanded
            ? "Close Section Chooser"
            : "Open Section Chooser",
        },
        domProps: {
          textContent: _vm._s(_vm.isExpanded ? "unfold_less" : "unfold_more"),
        },
        on: {
          click: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.handleHandleClick.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _vm.menu
        ? _c("div", { staticClass: "menu--section_nav_scroller" }, [
            _c(
              "ul",
              { staticClass: "menu--section_nav_list" },
              _vm._l(_vm.menu.sections, function (section) {
                return _c("menu-section-list-item-v2", {
                  key: "nav--" + section.ms_id,
                  attrs: {
                    section: section,
                    "is-highlighted":
                      _vm.highlightedSectionId === section.ms_id,
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.navButtonClickHandler(section)
                    },
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "menu--section_nav_overlay",
        class: { "menu--section_nav_overlay-active": _vm.isExpanded },
        on: {
          click: function ($event) {
            _vm.isExpanded = false
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }